// City routes — polylines (world X,Z at ground level) that both the animated
// neon WAYLINES and the CARS follow. These are approximate starter paths down
// the main axes; trace them onto the real streets with ?routes=edit (number
// keys select a route, , / . cycle the active point, arrows move it on X/Z,
// then paste the logged array back here). A saved override wins per machine.
//
// Each route: { id, color, points: [[x,z], …], cars, speed }
//   color  — neon tint of the wayline + the car glow
//   cars   — how many cars ride this route (evenly spaced)
//   speed  — units/sec along the path
export const CITY_ROUTES = [
  { id: 'r1', color: '#4fd1ff', points: [[-117, -5], [-83.7, -7.2], [-76.1, -9.2], [-76.8, -13.2], [0.4, -11.3], [-1.1, 13.6], [7.2, 14.1], [15.5, 14.5], [46, 13], [49, -8], [68, -8], [99, -8]], cars: 3, speed: 9 },
  { id: 'r2', color: '#ff5ea8', points: [[-90, 12], [-54, 12], [-54, 0], [-48, 0], [-45, -45], [-25.5, -45], [18, -45], [44.5, -45], [45.8, -1.5], [47, 42]], cars: 2, speed: 7 },
  { id: 'r3', color: '#9dff7d', points: [[-17, -90], [-17, -3], [-17, 95]], cars: 2, speed: 8 },
  { id: 'r4', color: '#ffb25e', points: [[16, -59], [16, -47], [22, -44], [25, -17], [17.5, -14.5], [13.8, 10.8], [7.4, 14.4], [-1.8, 14.7], [-119, 12]], cars: 2, speed: 6.5 },
];
